"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstantNodeDependencies = void 0;

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var ConstantNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createConstantNode: _factoriesAny.createConstantNode
};
exports.ConstantNodeDependencies = ConstantNodeDependencies;